'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _append2 = require('ramda/src/append');

var _append3 = _interopRequireDefault(_append2);

var _without2 = require('ramda/src/without');

var _without3 = _interopRequireDefault(_without2);

var _contains2 = require('ramda/src/contains');

var _contains3 = _interopRequireDefault(_contains2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = require('./Checkbox');

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxComponent = function (_Component) {
    _inherits(CheckboxComponent, _Component);

    function CheckboxComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CheckboxComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CheckboxComponent.__proto__ || Object.getPrototypeOf(CheckboxComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
            var values = _this.props.value;
            var value = e.target.value;


            _this.props.onChange((0, _contains3.default)(value, values) ? (0, _without3.default)([value], values) : (0, _append3.default)(value, values));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CheckboxComponent, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                language = _props.language,
                value = _props.value,
                disabled = _props.disabled,
                options = _props.options;


            return options.map(function (option) {
                return _react2.default.createElement(
                    _Checkbox.Checkbox.Label,
                    { key: option.id },
                    _react2.default.createElement(_Checkbox.Checkbox, {
                        onChange: _this2.onChange,
                        value: option.id,
                        checked: (0, _contains3.default)(option.id, value),
                        disabled: disabled }),
                    (0, _experiumPlayerHelpersLegacy.getText)(option, language)
                );
            });
        }
    }]);

    return CheckboxComponent;
}(_react.Component);

CheckboxComponent.propTypes = {
    value: _propTypes2.default.array,
    onChange: _propTypes2.default.func,
    options: _propTypes2.default.array,
    disabled: _propTypes2.default.bool,
    language: _propTypes2.default.string.isRequired
};
CheckboxComponent.defaultProps = {
    value: []
};
exports.default = (0, _withFieldWrapper2.default)(CheckboxComponent);